import { string } from '@iwentsourcing/core/typing/string.js';
import { TypeOfEvent } from '@iwentsourcing/core/typing/type-of.js';
import { declareEvent } from '@iwentsourcing/core/storage/declare-event.js';

export const CreateGroupEvent = declareEvent('create-group', {
  name: string(),
  groupId: string(),
});
export type CreateGroupEvent = TypeOfEvent<typeof CreateGroupEvent>;
